import { path_relative_to_absolute } from '@/utils/utils_files_client';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';

export function HOOK_IMAGE__download() {
  async function download_image(image_asset: DTO__image_asset) {
    if (image_asset.is_stub()) return;

    let url = path_relative_to_absolute(image_asset.url_relative);

    // Fetch the image as a blob
    const response = await fetch(url);
    const blob = await response.blob();

    // Create object URL from blob
    const blobUrl = window.URL.createObjectURL(blob);

    // Create temporary anchor element
    const link = document.createElement('a');
    link.href = blobUrl;

    link.download = image_asset.hash_sha256_content.remove_string_protocol() + '.webp';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);
  }

  return { download_image };
}
